"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpReopenModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var truncate_1 = __importDefault(require("lodash/truncate"));
var DpModal_1 = require("../Modal/DpModal");
var api_1 = require("../../../api");
var __1 = require("..");
var DpStudentsList_1 = __importDefault(require("./StudentsList/DpStudentsList"));
var DpReopenModal_styled_1 = require("./DpReopenModal.styled");
// pending to add error handling
var DpReopenModal = function (_a) {
    var show = _a.show, closeModal = _a.closeModal, assessment = _a.assessment, submitHandler = _a.submitHandler;
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var _c = (0, react_1.useState)([]), allStudents = _c[0], setAllStudents = _c[1];
    var _d = (0, react_1.useState)(false), allStudentsSelected = _d[0], setAllStudentsSelected = _d[1];
    var _e = (0, react_1.useState)([]), selectedStudents = _e[0], setSelectedStudents = _e[1];
    var _f = (0, react_1.useState)(false), showReopenButton = _f[0], setShowReopenButton = _f[1];
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var _g = (0, react_1.useContext)(api_1.ServiceContext), userService = _g.userService, attemptService = _g.attemptService, assessmentService = _g.assessmentService;
    var publish = (0, react_1.useContext)(__1.AlertManagerContext).publish;
    var selectStudent = function (allChecked, students) {
        var studentsSelection = students.filter(function (_a) {
            var selected = _a.selected;
            return selected;
        });
        setAllStudentsSelected(allChecked);
        setAllStudents(students);
        setSelectedStudents(studentsSelection);
        setShowReopenButton(!!studentsSelection.length);
    };
    var fetchStudents = function () { return __awaiter(void 0, void 0, void 0, function () {
        var students, studentAttempts, studentsSelection, studentsSelected;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userService.findByClass(assessment.assessmentClass.id)];
                case 1:
                    students = _a.sent();
                    return [4 /*yield*/, attemptService.findByAssessment(assessment.id, undefined, undefined, undefined, assessment.assessmentTemplate.curriculum)];
                case 2:
                    studentAttempts = _a.sent();
                    studentsSelection = [];
                    (0, sortBy_1.default)(students, ['lastName']).map(function (student) {
                        var studentAttemptObj = studentAttempts.find(function (attempt) { return attempt.assignee.id === student.id; });
                        if (studentAttemptObj) {
                            studentsSelection.push({
                                student: student,
                                selected: studentAttemptObj.status === 'closed',
                            });
                        }
                        return student;
                    });
                    setAllStudents(studentsSelection);
                    studentsSelected = studentsSelection.filter(function (student) { return student.selected; });
                    setSelectedStudents(studentsSelected);
                    setAllStudentsSelected(studentsSelection.length === studentsSelected.length);
                    setShowReopenButton(!!studentsSelected.length);
                    setInitialized(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var submitReopenButtonHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, assessmentService.reopen(assessment.id, new Date(), selectedStudents.map(function (_a) {
                        var student = _a.student;
                        return student.id;
                    }), assessment.assessmentTemplate.curriculum)];
                case 1:
                    _a.sent();
                    publish(__1.AlertOptions.info({
                        alert: {
                            message: t('reopenModal.reopenSuccess', {
                                assessmentName: "".concat(assessment.assessmentTemplate.title),
                            }),
                            actionLabel: t('reopenModal.ok'),
                        },
                    }));
                    if (submitHandler) {
                        submitHandler();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0, api_1.useMount)(function () {
        fetchStudents();
    });
    return ((0, jsx_runtime_1.jsxs)(DpReopenModal_styled_1.StyledReopenModal, { show: show, onHide: closeModal, size: "lg", "aria-labelledby": "reopen-modal-title", curriculum: assessment.assessmentTemplate.curriculum, children: [(0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Header, { children: (0, jsx_runtime_1.jsxs)("div", { className: "title", children: [(0, jsx_runtime_1.jsx)("p", { id: "reopen-modal-title", children: t('reopenModal.reopenHeading') }), (0, jsx_runtime_1.jsx)("div", { className: "assessment-title", children: (0, jsx_runtime_1.jsx)("h1", { className: "h3", children: assessment.assessmentTemplate.title }) })] }) }), initialized ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(DpModal_1.DpModal.Body, { children: [(0, jsx_runtime_1.jsx)("p", { children: t('reopenModal.assessmentReopenedTo', {
                                    studentCount: selectedStudents.length,
                                    student: selectedStudents.length === 1 ? 'student' : 'students',
                                }) }), (0, jsx_runtime_1.jsxs)("p", { className: "reopen-warning", children: [(0, jsx_runtime_1.jsx)(__1.Icon, { name: "warning", size: 30 }), assessment.assessmentTemplate.isDiagnostic
                                        ? t('reopenModal.equipAssessmentWarning')
                                        : t('reopenModal.nonEquipAssessmentWarning')] }), (0, jsx_runtime_1.jsxs)("div", { className: "class-item", tabIndex: 0, role: "tablist", children: [(0, jsx_runtime_1.jsx)("div", { className: "class-tab", role: "tab", tabIndex: -1, "data-index": "0", children: (0, jsx_runtime_1.jsx)("span", { className: "class-info", id: "class-".concat(assessment.assessmentClass.id), children: (0, truncate_1.default)(assessment.assessmentClass.displayName, {
                                                length: 57,
                                                separator: ' ',
                                            }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "students-tab", role: "tab", tabIndex: -1, "data-index": "1", children: (0, jsx_runtime_1.jsx)("span", { children: allStudentsSelected
                                                ? t('reopenModal.allStudents')
                                                : "".concat(selectedStudents.length, " / ").concat(allStudents.length, " Students") }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "tab-content", children: (0, jsx_runtime_1.jsx)(DpStudentsList_1.default, { students: allStudents, allStudentsSelected: allStudentsSelected, selectHandler: selectStudent }) })] }), (0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Footer, { children: (0, jsx_runtime_1.jsx)("div", { className: "actions", children: (0, jsx_runtime_1.jsx)(__1.DpLoadingWrapper, { onClick: submitReopenButtonHandler, className: "submit-button", disabled: !showReopenButton, "data-testid": "reopenBtn", children: t('reopenModal.reopenButton') }) }) })] })) : ((0, jsx_runtime_1.jsx)(__1.Spinner, { className: "spinner", ariaLabel: t('reopenModal.fetchingInformation') }))] }));
};
exports.DpReopenModal = DpReopenModal;
exports.default = exports.DpReopenModal;
